
export const OPEN_DIALOG = 'OPEN_DIALOG';

export const updateOpenDialog = isOpen => {
  return {
    type: OPEN_DIALOG,
    payload: isOpen
  }
}


export const SELECTED_DEVICE_ID = "SELECTED_DEVICE_ID";

export const updateSelectedDeviceId = deviceId => {

  return {
    type: SELECTED_DEVICE_ID,
    payload: deviceId
  }
}


export const SELECTED_DEVICE_LABEL = "SELECTED_DEVICE_LABEL";

export const updateSelectedDeviceLabel = label => {
  return {
    type: SELECTED_DEVICE_LABEL,
    payload: label
  }
}



// 센서 디바이스 다이어로그창에서, 선택된 센서 정보 레코드
export const OPEN_DEVICE_SEARCH_DIALOG = "OPEN_DEVICE_SEARCH_DIALOG";
export const updateOpenDeviceSearchDialog = isOpen => {
  return {
    type: OPEN_DEVICE_SEARCH_DIALOG,
    payload: isOpen
  }
}

export const WHICH_DEVICE = "WHITCH_DEVICE";
export const updateWhichDevice = witchDevice => {
  return {
    type: WHICH_DEVICE,
    payload: witchDevice
  }
}


//모든 수면분석용 디바이스 리스트
export const SELECT_SLEEP_DEVICE = "SELECT_SLEEP_DEVICE";
export const updateSelectedDeviceForSleep = selectedDevice => {

  // console.log('Dispatched updateSelectedDeviceForSleep with:', selectedDevice);

  return {
    type: SELECT_SLEEP_DEVICE,
    payload: selectedDevice
  }
}